module.exports = __webpack_public_path__ + "assets/img/00125.49a5e03a.png";